import { Box, Link, Typography } from '@mui/material';

const OFFICIAL_DIGIPIN = 'https://www.indiapost.gov.in/digipin';

export type DigipinDisclaimerVariant = 'inline' | 'banner' | 'footer';

interface DigipinDisclaimerProps {
  variant?: DigipinDisclaimerVariant;
  /** Extra class / sx merge for parent layouts */
  sx?: object;
}

/**
 * Legal notice: GeoVera is not the official India Post DIGIPIN service.
 */
export default function DigipinDisclaimer({ variant = 'inline', sx }: DigipinDisclaimerProps) {
  const text = (
    <>
      DIGIPIN is an India Post digital address system. GeoVera is an independent WebGIS platform
      that implements DIGIPIN tools for convenience —{' '}
      <strong>not an official India Post product</strong>. Official info:{' '}
      <Link
        href={OFFICIAL_DIGIPIN}
        target="_blank"
        rel="noopener noreferrer"
        sx={{ color: 'inherit', textDecoration: 'underline', fontWeight: 600 }}
      >
        indiapost.gov.in/digipin
      </Link>
      .
    </>
  );

  if (variant === 'footer') {
    return (
      <Typography
        component="p"
        sx={{
          color: '#64748B',
          fontSize: 11,
          lineHeight: 1.55,
          maxWidth: 720,
          ...sx,
        }}
      >
        {text}
      </Typography>
    );
  }

  if (variant === 'banner') {
    return (
      <Box
        role="note"
        sx={{
          px: 2,
          py: 1.25,
          borderRadius: 2,
          bgcolor: 'rgba(217, 119, 6, 0.1)',
          border: '1px solid rgba(217, 119, 6, 0.35)',
          color: '#FBBF24',
          fontSize: 12,
          lineHeight: 1.5,
          ...sx,
        }}
      >
        {text}
      </Box>
    );
  }

  return (
    <Typography
      component="p"
      sx={{
        color: '#94A3B8',
        fontSize: 12,
        lineHeight: 1.55,
        ...sx,
      }}
    >
      {text}
    </Typography>
  );
}

export { OFFICIAL_DIGIPIN };
